import { combineReducers } from "redux";
import { userReducer } from "./user";
import { selectedReducer } from "./selected";
import { reloadReducer } from "./reload";
import overviewReducer from "./overview";

export default combineReducers({
  user: userReducer,
  selected: selectedReducer,
  reload:reloadReducer,
  overview: overviewReducer
});